import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  onEnrollClick?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onEnrollClick }) => {
  const location = useLocation();
  const isCAPPage = location.pathname === '/cap' || location.pathname === '/sales';

  return (
    <nav className="py-4 px-4 bg-white sticky top-0 z-50 border-b border-gray-100">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img 
            src={`${process.env.PUBLIC_URL}/ks-svg.svg`}
            alt="KloudSkool" 
            className="w-[180px] h-[34px]"
            style={{ objectFit: 'contain' }}
          />
        </Link>
        
        {isCAPPage && onEnrollClick && (
          <div className="flex items-center">
            <button 
              onClick={onEnrollClick}
              className="bg-[#F97316] text-white font-medium px-6 py-2 rounded-md hover:bg-[#F97316]/90 transition-colors duration-200"
            >
              Enroll Now
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 